import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import BookingDataService from "../../services/Booking";

export const TherapyDateTimeModal = ({ isOpen, onClose, func, id }: any) => {
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const handleDateChange = (e: any) => {
    const date = new Date(e.target.value);
    const formattedDate = `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date
      .getFullYear()
      .toString()}`;
    setSelectedDate(formattedDate);
  };

  const handleTimeChange = (e: any) => {
    const [hours, minutes] = e.target.value.split(":");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedTime = `${formattedHours}:${formattedMinutes} ${period}`;
    setSelectedTime(formattedTime);
  };
  const handleSubmit = () => {

    const data = {
      session_date: selectedDate,
      session_time: selectedTime,
      post_session_status: "",
    };
    if (selectedDate && selectedTime) {
      BookingDataService.updateBooking(data, id)
        .then((res) => {
          func();
          closeModal();
        })
        .catch((error: any) => {
          console.log(error);
          closeModal();
        });
    }
  };

  const closeModal = () => {
    clearState();
    onClose();
  };
  const clearState = () => {
    setSelectedDate("");
    setSelectedTime("");
  };

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select therapy date and time</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel htmlFor="level-select">Select therapy date</FormLabel>
            <Input type="date" onChange={handleDateChange} />
          </FormControl>
          <FormControl mt={5}>
            <FormLabel htmlFor="time-select">Select therapy time</FormLabel>
            <Input type="time" onChange={handleTimeChange} />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={closeModal}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
